import { CONSTANTS } from "shared/constants";
import API from "core/api";

const defaultState = {
  create_contentview_request_status: CONSTANTS.FETCH.STANDBY,
  get_contentview_request_status: CONSTANTS.FETCH.STANDBY,
};

const actionTypes = {
  CONTENTVIEWS_REQUEST_STARTED: "REACTIONS_REQUEST_STARTED",
  CONTENTVIEWS_REQUEST_FINISHED: "REACTIONS_REQUEST_FINISHED",
};

const requestStarted = (payload, dispatch) => {
  dispatch({ type: actionTypes.CONTENTVIEWS_REQUEST_STARTED, payload });
};

const requestFinished = (payload, dispatch, response, callback) => {
  dispatch({ type: actionTypes.CONTENTVIEWS_REQUEST_FINISHED, payload });
  callback(response);
};

const actions = {
  createContentView:
    (data, model, callback = () => {}) =>
    (dispatch) => {
      requestStarted(
        {
          create_contentview_request_status: CONSTANTS.FETCH.PROGRESS,
        },
        dispatch
      );

      const successCallback = (response) =>
        requestFinished(
          {
            create_contentview_request_status: CONSTANTS.FETCH.SUCCESS,
          },
          dispatch,
          response,
          callback
        );

      const errorCallback = (response) =>
        requestFinished(
          {
            create_contentview_request_status: CONSTANTS.FETCH.FAILED,
          },
          dispatch,
          response,
          callback
        );

      API.panzofi.createContentView(
        data,
        model,
        successCallback,
        errorCallback
      );
    },
  getContentView:
    (id, callback = () => {}) =>
    (dispatch) => {
      requestStarted(
        {
          get_contentview_request_status: CONSTANTS.FETCH.PROGRESS,
        },
        dispatch
      );

      const successCallback = (response) =>
        requestFinished(
          {
            get_contentview_request_status: CONSTANTS.FETCH.SUCCESS,
          },
          dispatch,
          response,
          callback
        );

      const errorCallback = (response) =>
        requestFinished(
          {
            get_contentview_request_status: CONSTANTS.FETCH.FAILED,
          },
          dispatch,
          response,
          callback
        );

      API.panzofi.getContentView(id, successCallback, errorCallback);
    },
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.REACTIONS_REQUEST_FINISHED:
      return {
        ...state,
        ...action.payload,
      };

    case actionTypes.REACTIONS_REQUEST_STARTED:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default {
  defaultState,
  actionTypes,
  actions,
  reducer,
};
